import { PaymentMethodDetails } from "../../../models";

interface Props {
  savedCard: PaymentMethodDetails;
}

const SavedCard = ({ savedCard }: Props) => {
  const { type, isRewardsCard, mask, name } = savedCard;
  const paymentType = isRewardsCard ? "Rewards" : type;

  if (!type) {
    return (
      <span className="inline-block text-[11px] leading-none py-1 ml-2 m-0">
        Select A Card
      </span>
    );
  }

  return (
    <>
      <span
        className={`credit-icon credit-icon--${paymentType
          .toLowerCase()
          .replace(" ", "")}-sm p-0`}
      >
        {paymentType}
      </span>
      <span className="inline-block text-[11px] text-left leading-none ml-2">
        <strong>{mask}</strong>
        <br />
        {name}
      </span>
    </>
  );
};

export default SavedCard;
